export const GET_MONITORING_DATA = 'dashboard/GET_MONITORING_DATA';
export const SEND_MONITORING = 'dashboard/SEND_MONITORING';
export const DATA = 'dashboard/DATA';

export const COUNTS_LIST_LOADED = 'dashboard/paginate/COUNTS_LIST_LOADED';